<script>
  import solicitacaoContratacaoPessoalServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';
  import tiposConta from '~js/tipos-conta';
  import tiposPix from '~js/tipos-pix';
  import ListaEventos from './compartilhado/FormListaEventos.vue';
  import ResumoEventos from './compartilhado/FormResumoEventos.vue';
  
  export default {
    components: { Cabecalho, Barcode, ListaEventos, ResumoEventos },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        tiposConta: tiposConta,
        tiposPix: tiposPix,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoContratacaoPessoalServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoPix(id) {
        return this.tiposPix.find(t => {
          return t.id === id;
        });
      },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      vinculoFundacaoTexto() {
        switch (this.solicitacao.vinculoFundacao) {
          case 0:
          case "0":
            return 'Não sei informar'
          case 1:
          case "1":
            return 'Contratação Autônomo'
          case 2:
          case "2":
            return 'Contratação PJ'
        }

        return '---'
      },
      tipoSolicitacaoTexto() {
        switch (this.solicitacao.tipoSolicitacao) {
          case "1":
            return 'Celetista'
            break
          case "2":
            return 'Estagiário'
            break
        }

        return '---'
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Contratação Pessoal - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-contratacao-pessoal';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <cabecalho :titulo="'Solicitação de Contratação Pessoal'"></cabecalho>

              <h3 class="m-t-none m-b">Dados da solicitação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-8">
                  <dt>Projeto</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Tipo de projeto</dt>
                  <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Período de vigência</dt>
                  <dd>{{ periodoDeVigencia }}</dd>
                </dl>

                <dl class="col-xs-6">
                  <dt>Nr. processo</dt>
                  <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.idSolicitacaoContratacaoPessoal || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Data da solicitação</dt>
                  <dd>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Coordenador do projeto</dt>
                  <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Data de liberação do coordenador</dt>
                  <dd>{{ solicitacao.dataCoordenadorLibCanc | formatarData }} - {{ solicitacao.dataCoordenadorLibCanc | formatarHora }}</dd>
                </dl>
     
                <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                  <dt>Liberado por</dt>
                  <dd>{{ solicitacao.liberadoCanceladoCoordenadorPor ? solicitacao.liberadoCanceladoCoordenadorPor.nomePessoaFisicaJuridica : '---' }}</dd>
                </dl>
                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Nº protocolo</dt>
                  <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                </dl>

                <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                  <dt>Código de barras protocolo</dt>
                  <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados cadastrais</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Nome</dt>
                  <dd>{{ solicitacao.nomeRequerinte || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>CPF</dt>
                  <dd>{{ solicitacao.cpf || '---' }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Data de nascimento</dt>
                  <dd>{{ solicitacao.dataNascimento | formatarNumeroEmData('---') }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Tipo solicitação</dt>
                  <dd>{{ tipoSolicitacaoTexto || '---' }}</dd>
                </dl>
                
              </div>

              <div class="row">
                <dl class="col-xs-6">
                  <dt>Endereço</dt>
                  <dd>{{ solicitacao.endereco || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Número</dt>
                  <dd>{{ solicitacao.numero || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Complemento</dt>
                  <dd>{{ solicitacao.complemento || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Bairro</dt>
                  <dd>{{ solicitacao.bairro || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Cidade</dt>
                  <dd>{{ solicitacao.cidade || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Estado</dt>
                  <dd>{{ solicitacao.uf || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Telefone</dt>
                  <dd>{{ solicitacao.telefone || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>Celular</dt>
                  <dd>{{ solicitacao.celular || '---' }}</dd>
                </dl>

                <dl class="col-xs-4">
                  <dt>E-mail do beneficiário</dt>
                  <dd>{{ solicitacao.email || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados contratação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-2">
                  <dt>Salário bruto</dt>
                  <dd>{{ solicitacao.salarioBruto || '---' }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Vínculo com a fundação</dt>
                  <dd>{{ vinculoFundacaoTexto || '---' }}</dd>
                </dl>

                <dl class="col-xs-5">
                  <dt>Função</dt>
                  <dd>{{ solicitacao.funcao || '---' }}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Data início</dt>
                  <dd>{{ solicitacao.dataInicioContratacao || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-3">
                  <dt>Horário trabalho</dt>
                  <dd>{{ solicitacao.horarioTrabalho || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Horário descanso</dt>
                  <dd>{{ solicitacao.horarioDenscanso || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Local trabalho</dt>
                  <dd>{{ solicitacao.localTrabalho || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Telefone trabalho</dt>
                  <dd>{{ solicitacao.telefoneTrabalho || '---' }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Justificativa contratação</dt>
                  <dd>{{ solicitacao.justificativaContratacao || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Dados bancários</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row" v-if="solicitacao.tipoConta != 4">
                <dl class="col-xs-3">
                  <dt>Banco</dt>
                  <dd>{{ solicitacao.banco || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Agência</dt>
                  <dd>{{ solicitacao.agencia || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Conta</dt>
                  <dd>{{ solicitacao.conta || '---' }}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Tipo de conta</dt>
                  <dd>{{ solicitacao.tipoConta ? tipoConta(solicitacao.tipoConta).nome : '---' }}</dd>
                </dl>
              </div>

              <div class="row" v-if="solicitacao.tipoConta == 4">
                <dl class="col-xs-3">
                  <dt>Tipo pix</dt>
                  <dd>{{ solicitacao.tipoPix ? tipoPix(solicitacao.tipoPix).nome : '---' }}</dd>
                </dl>

                <dl class="col-xs-9">
                  <dt>Chave PIX</dt>
                  <dd>{{ solicitacao.chavePix || '---' }}</dd>
                </dl>
              </div>

              <h3 class="m-t-none m-b">Benefícios</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div>
                <lista-eventos :eventos="solicitacao.eventos"
                               :relatorio="true">
                </lista-eventos>
              </div>

              <h3 class="m-t-none m-b">Resumo contratação</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div>
                <resumo-eventos ref="resumo"
                                :solicitacao.sync="solicitacao"
                                :relatorio="true">
                </resumo-eventos>
              </div>

              <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solContratacaoPessoalMsgConfirmacao"></div>

              <div class="row" v-if="this.configuracao.solContratacaoPessoalMsgConfirmacao">
                <div class="col-md-12">
                  <p><i>{{this.configuracao.solContratacaoPessoalMsgConfirmacao}}</i></p>
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/SolicitacaoContratacaoPessoalRelatorio.vue